export const DINING_DATES_IN = "YYYY-MM-DD";
export const DINING_DATES_OUT = "ddd D MMM";
export const DINING_TIMES_IN = "YYYY-MM-DD HH:mm:ss";
export const DINING_TIMES_OUT = "h:mm A";

export const ADDON_DATE_IN = "YYYY-MM-DD";
export const ADDON_DATE_OUT = "ddd, D MMM";
